module.exports = __webpack_public_path__ + "static/media/filterIcon.934a5062.svg";